
import { Link } from 'react-router-dom';

const insurancePlans = [
  {
    icon: 'ri-user-heart-line',
    title: 'Individual & Family Plans',
    description: 'Comprehensive health coverage for you and your loved ones with flexible options to fit your budget and healthcare needs.',
    features: [
      'Preventive care coverage',
      'Prescription drug benefits',
      'Nationwide provider networks',
      'Affordable premium options'
    ],
    color: 'sky'
  },
  {
    icon: 'ri-building-line',
    title: 'Group & Employer Plans',
    description: 'Cost-effective health insurance solutions for businesses of all sizes, helping you attract and retain top talent.',
    features: [
      'Small & large group options',
      'Competitive rates',
      'Employee wellness programs',
      'Easy enrollment process'
    ],
    color: 'emerald'
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Medicare Supplement',
    description: 'Fill the gaps in Original Medicare with supplemental coverage that helps reduce out-of-pocket costs for seniors.',
    features: [
      'Plans A through N available',
      'No network restrictions',
      'Guaranteed renewable',
      'Predictable costs'
    ],
    color: 'indigo'
  },
  {
    icon: 'ri-time-line',
    title: 'Short-Term Health Insurance',
    description: 'Temporary coverage for gaps between jobs, waiting periods, or other transitional life situations.',
    features: [
      'Quick approval process',
      'Flexible coverage periods',
      'Lower premium costs',
      'Immediate protection'
    ],
    color: 'amber'
  }
];

export default function InsurancePlansPreview() {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            <strong>Health Insurance Plans</strong> We Offer
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From individual coverage to group plans, we help you find the right health insurance solution for your unique situation.
          </p>
        </div>
        
        {/* Plans Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {insurancePlans.map((plan, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-${plan.color}-100 rounded-lg mb-6`}>
                <i className={`${plan.icon} text-3xl text-${plan.color}-600`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-slate-900 mb-3">{plan.title}</h3>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">{plan.description}</p>
              
              <ul className="space-y-3 mb-6">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-emerald-500 text-lg mt-0.5"></i>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Link 
                to="/insurance-plans"
                className="whitespace-nowrap inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 font-semibold text-sm cursor-pointer transition-colors"
              >
                Learn More <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
        
        {/* CTA Button */}
        <div className="text-center">
          <Link 
            to="/insurance-plans"
            className="whitespace-nowrap inline-block px-8 py-4 bg-slate-900 hover:bg-slate-800 text-white text-lg font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            View All Insurance Plans
          </Link>
        </div>
      </div>
    </section>
  );
}
